export default {
  data() {
    return {
      sms: [
        {
          id: 1,
          name: "status",
          alias: "status"
        },

        {
          id: 2,
          name: "preset",
          alias: "preset"
        }
      ]
    };
  }
};
